import { getField, updateField } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { HTTP } from "@/http-common";
import {CustomerDetail} from "../../../models/CustomerDetail";
const state = {
    // rows: [],
    message: new httpError(),
};
const rows = [];

const getters = {
    getField,
    getCustomerDetailsArray(){
        // use only getters.bigArray in other getters
        return rows;
    }  
};

//Mutations
const mutations = {
    setCustomerDetail(state, customerDetails) {
        // state.filteredRows = customerDetails.filter((x) => x.customerNumber);
        this.rows = customerDetails.data;
    },
    addRow(state) {
        if (state.rows.length > 0) {
            state.rows.push(new CustomerDetail());
        } else {
            state.rows = [new CustomerDetail()];
        }
    },
    deleteRow(state) {
        // To enable multi-row form handling
        // we make it possible to add new rows.
        state.rows.pop();
    },
    setProgress(state, message) {
        state.message = message;
    },
    removeRow(state, index) {
        state.rows.splice(index, 1);
    },
    updateField,
};

//ACTIONS
const actions = {
    reset({ commit }) {
        commit("setCustomerDetail", [
            new CustomerDetail(),
        ]);
    },
    addCustomerDetail({ state, commit }) {
        return new Promise((resolve) => {
            commit("addRow");
            resolve(state.rows.length - 1);
        });
    },
    async getCustomerDetails() {
        return new Promise(async (resolve, reject) => {
            try {
                var response = await HTTP.get("Wholesale/GetCustomerContactEmail");
                if (response.status !== 200) resolve(response);
                var result = response.data;
                resolve(result);
            } catch (err) {
                reject(err);
            }
        });
    },
    async getCustomerContacts() {
        return new Promise(async (resolve, reject) => {
            try {
                var response = await HTTP.get("Wholesale/GetCustomerDetailsWithValidPlan");
                if (response.status !== 200) resolve(response);
                var result = response.data;
                resolve(result);
            } catch (err) {
                reject(err);
            }
        });
    },
    updateContactEmail ({ dispatch }, request) {
        return new Promise((resolve, reject) => {
            let response = HTTP.post(
                "Wholesale/UpdateNotificationEmail/" + request.oldEmail,
                request.item
            );
            response
                .then((data) => {
                    dispatch(
                        "setMessage",
                        new httpError({ message: "Updated OK", httpStatus: 200 })
                    );
                    resolve(data.data);
                })
                .catch((err) => {
                    dispatch(
                        "setMessage",
                        new httpError({
                            message: "Not saved:" + err.message,
                            httpStatus: 500,
                        })
                    );
                    reject(err);
                });
        });
    },
    updateContact ({ dispatch }, request) {
        return new Promise((resolve, reject) => {
            let response = HTTP.post(
                "Wholesale/UpdateContactEmailNumber",
                request
            );
            response
                .then((data) => {
                    dispatch(
                        "setMessage",
                        new httpError({ message: "Updated OK", httpStatus: 200 })
                    );
                    resolve(data.data);
                })
                .catch((err) => {
                    dispatch(
                        "setMessage",
                        new httpError({
                            message: "Not saved:" + err.message,
                            httpStatus: 500,
                        })
                    );
                    reject(err);
                });
        });
    },
    setMessage({ commit }, message) {
        commit("setProgress", message);
        if (message.httpStatus !== 500)
            setTimeout(() => {
                commit("setProgress", new httpError());
            }, 2000);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
